import { usePintMaster, createControlField } from '@lib/common';
import { TextField } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import styled from 'styled-components';

const LanguageAutoComplete = ({ value, onChange }) => {
  const { loading, master: languages } = usePintMaster('languages');
  return (
    <GenreStyles>
      <Autocomplete
        size="small"
        value={value as typeof languages[number]}
        onChange={(evt, v) => onChange && onChange(v)}
        loading={loading}
        disabled={loading}
        options={languages || []}
        getOptionLabel={value => value.name}
        renderInput={props => (
          <TextField
            helperText="Select the original language in which this content was released."
            label={loading ? 'Language (Loading...)' : 'Language'}
            placeholder={loading ? 'Language (Loading...)' : 'Language'}
            fullWidth
            variant="outlined"
            {...props}
          />
        )}
      />
    </GenreStyles>
  );
};

const GenreStyles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const LanguageField = createControlField(LanguageAutoComplete, null);
